import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import home from './modules/home';
import cluesManage from './modules/cluesManage';
import message from './modules/message';
import order from './modules/order';
import product from './modules/product';
import channel from './modules/channel';
import CustomerSource from './modules/CustomerSource';
import SourceDetails from './modules/SourceDetails';
import navbar from './modules/navbar';
import listen from './modules/listen';
import navigation from './modules/navigation';
import MarketingActivity from './modules/cluesManage';
import SaleNewClueList1 from './modules/cluesManage';
import callInfo from './modules/callinfo'
Vue.use(Vuex);
export default new Vuex.Store({
    getters,
    modules: {
        home,
        cluesManage,
        message,
        order,
        product,
        channel,
        navbar,
        navigation,
        listen,
        CustomerSource,
        SourceDetails,
        MarketingActivity,
        SaleNewClueList1,
        callInfo
    },
    strict: false
})